var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSystemMoveForwardOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.646 2.813a.5.5 0 0 0 0 .707L10.126 8l-4.48 4.48a.5.5 0 1 0 .708.707l4.833-4.834a.5.5 0 0 0 0-.707L6.354 2.813a.5.5 0 0 0-.708 0Z",
  fill: "#1C1C1C"
})));
export default SvgIcSystemMoveForwardOutline;